export const getCurrentTimezoneOffset= (): number => {
  return -(new Date()).getTimezoneOffset() / 60;
}